export const IFRAME_DARK_MODE_MESSAGE = "FLUIDSDATA_DARK_MODE";
export const IFRAME_TENANT_MESSAGE = "FLUIDSDATA_TENANT";
export const IFRAME_POINTER_MESSAGE = "FLUIDSDATA_IFRAME_POINTER";
export const IFRAME_PVT_ROUTE_MESSAGE = "FLUIDSDATA_PVT_ROUTE";
export const PVT_ROUTE_CHANGED_MESSAGE = "PVT_ROUTE_CHANGED";

export function getIframeOrigin(envUrl) {
  if (!envUrl) return null;
  try {
    return new URL(envUrl).origin;
  } catch {
    return null;
  }
}

export function notifyIframeDarkMode(iframeEl, isDarkMode, envUrl) {
  const origin = getIframeOrigin(envUrl);
  if (!iframeEl?.contentWindow || !origin) return;
  iframeEl.contentWindow.postMessage(
    { type: IFRAME_DARK_MODE_MESSAGE, darkMode: !!isDarkMode },
    origin
  );
}

export function notifyIframeTenant(iframeEl, tenantId, envUrl) {
  const origin = getIframeOrigin(envUrl);
  const id = String(tenantId || "").trim();
  if (!iframeEl?.contentWindow || !origin || !id) return;
  iframeEl.contentWindow.postMessage(
    { type: IFRAME_TENANT_MESSAGE, tenantId: id },
    origin
  );
}

export function notifyIframePvtRoute(iframeEl, pathname, envUrl) {
  const origin = getIframeOrigin(envUrl);
  if (!iframeEl?.contentWindow || !origin) return;
  iframeEl.contentWindow.postMessage(
    { type: IFRAME_PVT_ROUTE_MESSAGE, pathname: pathname || "/" },
    origin
  );
}
